import { types } from "../../types/types";

const initialState = {
  loading: false,
  contactos: [],
  contactoEditDelete: null,
  openDeleteConfirmModal: false,
  openCreateEditModal: false,
  tipoContacto: [],
  observacionesContacto:[]
};

export const contratacionesContactosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.contratacionesTraerContactoStart:
      return {
        ...state,
        loading: true
      }
    case types.contratacionesTraerContactoSuccess:
      return {
        ...state,
        contactos: action.payload,
      }
    case types.contratacionesTraerContactoError:
      return {
        ...state,
        contactos: [],
        loading: false
      }
      case types.contratacionesTraerObservacionesContactoStart:
      return {
        ...state,
        loading: true
      }
    case types.contratacionesTraerObservacionesContactoSuccess:
      return {
        ...state,
        observacionesContacto: action.payload,
      }
    case types.contratacionesTraerObservacionesContactoError:
      return {
        ...state,
        observacionesContacto: [],
        loading: false
      }
    case types.contratacionesTraerTipoContactoStart:
      return {
        ...state,
        loading: true
      }
    case types.contratacionesTraerTipoContactoSuccess:
      return {
        ...state,
        loading: false,
        tipoContacto: action.payload,
      }
    case types.contratacionesTraerTipoContactoError:
      return {
        ...state,
        tipoContacto: [],
        loading: false
      }
    case types.contratacionesSetearContactoEditDelete:
      return {
        ...state,
        contactoEditDelete: action.payload,
      }
    case types.contratacionesOpenDeleteConfirmModalEfector:
      return {
        ...state,
        openDeleteConfirmModal: action.payload,
      }
    case types.contratacionesOpenCreateEditModalEfector:
      return {
        ...state,
        openCreateEditModal: action.payload,
      }
    case types.contratacionesGuardarContrato:
      return {
        ...state,
        dataContrato: action.payload,
      }
    default:
      return state;
  }
};